<div class="main-bg h-100"></div>
<div class="w-100 h-100 absolute content flex-row-center-center">
  <ng-content></ng-content>
</div>
